import { Dispatch, useState } from 'react';
import { NextLink } from 'components/NextLink';
import { Button } from 'components/Button';
import { UserPhoto } from 'components/UserPhoto';
import { CurrentUser, SimpleCustomer } from 'types';
import { postCustomerData } from 'api';
import { checkIfFullyAuthorized, toAuthAndBack } from 'utils/services';

import styles from './CustomersList.module.scss';
import { SnackbarProps } from '../Snackbar';

export type CustomersListItemProps = {
  currentUser?: CurrentUser;
  useDirectLinks?: boolean;
  onFollowed?: (followed: boolean) => void;
  user: SimpleCustomer;
  setSnackbarMessage: Dispatch<SnackbarProps | null>;
};

export const CustomersListItem = ({ currentUser, user, onFollowed, useDirectLinks, setSnackbarMessage }: CustomersListItemProps) => {
  const [isFollowed, setIsFollowed] = useState<boolean>(user.is_followed);
  const [isFollowingProcess, setIsFollowingProcess] = useState<boolean>(false);
  const isFullyAuth = checkIfFullyAuthorized(currentUser);

  const handleFollow = async () => {
    if (isFollowingProcess) {
      return;
    }

    setIsFollowingProcess(true);
    const result = await postCustomerData(user.username, 'follow');

    if (result.ok) {
      onFollowed && onFollowed(!isFollowed);
      setIsFollowed(!isFollowed);
    } else {
      setSnackbarMessage({header: result.message || result.error || 'Failed to follow user', mode: 'error'})
    }
    setIsFollowingProcess(false);
  };

  return (
    <div className={styles.usersListItem}>
      <NextLink href={`/users/${user.username}`}>
        <div className={styles.userPhoto}>
          <UserPhoto src={user.photo || ''} alt={user.full_name} layout="fill" objectFit="cover" />
        </div>
      </NextLink>
      <div className={styles.userDetails}>
        <NextLink href={`/users/${user.username}`} useDirectLink={useDirectLinks}>
          <div className={styles.userDetailsName}>{user.full_name}</div>
        </NextLink>
        <NextLink href={`/users/${user.username}`} useDirectLink={useDirectLinks}>
          <div className={styles.userDerailsUsername}>@{user.username}</div>
        </NextLink>
      </div>
      {currentUser && currentUser.id !== user.id && (
        <div className={styles.followAction}>
          <Button
            caption={isFollowed ? 'Unfollow' : 'Follow'}
            action={isFullyAuth ? handleFollow : () => toAuthAndBack(`users/${user.username}`, null, currentUser)}
            disabled={isFollowingProcess}
            buttonHeight="low"
            buttonType="whiteBlue"
          />
        </div>
      )}
    </div>
  );
};
